import { default as indexxkK4ebspFOMeta } from "/var/lib/jenkins/workspace/taro-trip-production/src/pages/index.vue?macro=true";
import { default as indexe55LUCecEPMeta } from "/var/lib/jenkins/workspace/taro-trip-production/src/pages/aboutUs/index.vue?macro=true";
import { default as indexKDUDy9cFeDMeta } from "/var/lib/jenkins/workspace/taro-trip-production/src/pages/addPassenger/index.vue?macro=true";
import { default as indexMfxDiBfikcMeta } from "/var/lib/jenkins/workspace/taro-trip-production/src/pages/confirmation/index.vue?macro=true";
import { default as indexpR8M0pnjMpMeta } from "/var/lib/jenkins/workspace/taro-trip-production/src/pages/contactUs/index.vue?macro=true";
import { default as _91id_93BviohoFIHGMeta } from "/var/lib/jenkins/workspace/taro-trip-production/src/pages/destination/[id].vue?macro=true";
import { default as index1EzbM2KwCvMeta } from "/var/lib/jenkins/workspace/taro-trip-production/src/pages/familyAndFriends/index.vue?macro=true";
import { default as indexWz9U3w8wy6Meta } from "/var/lib/jenkins/workspace/taro-trip-production/src/pages/flightLoading/index.vue?macro=true";
import { default as _91toCity_93Ud2TO2thAOMeta } from "/var/lib/jenkins/workspace/taro-trip-production/src/pages/flights/search/[fromCity]/[toCity].vue?macro=true";
import { default as indexOYN7gUbbCgMeta } from "/var/lib/jenkins/workspace/taro-trip-production/src/pages/help/index.vue?macro=true";
import { default as _91id_93JLUGcVLIUIMeta } from "/var/lib/jenkins/workspace/taro-trip-production/src/pages/hotDeals/[id].vue?macro=true";
import { default as indext7YOkuj35eMeta } from "/var/lib/jenkins/workspace/taro-trip-production/src/pages/luggagePayments/index.vue?macro=true";
import { default as _91id_932XpjuTRLKXMeta } from "/var/lib/jenkins/workspace/taro-trip-production/src/pages/orderDetail/[id].vue?macro=true";
import { default as indexb0t9BMXb2zMeta } from "/var/lib/jenkins/workspace/taro-trip-production/src/pages/orderList/index.vue?macro=true";
import { default as indexFQZvbF57BNMeta } from "/var/lib/jenkins/workspace/taro-trip-production/src/pages/payComplete/index.vue?macro=true";
import { default as indextbRLLu6mYrMeta } from "/var/lib/jenkins/workspace/taro-trip-production/src/pages/payments/index.vue?macro=true";
import { default as indexFqLAPZvvYLMeta } from "/var/lib/jenkins/workspace/taro-trip-production/src/pages/personalInformation/index.vue?macro=true";
import { default as indexqXZXFvdf16Meta } from "/var/lib/jenkins/workspace/taro-trip-production/src/pages/policyContent/index.vue?macro=true";
import { default as indexwCnobILRbqMeta } from "/var/lib/jenkins/workspace/taro-trip-production/src/pages/refundPayments/index.vue?macro=true";
import { default as indexvYCTxt37LQMeta } from "/var/lib/jenkins/workspace/taro-trip-production/src/pages/termService/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexxkK4ebspFOMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "aboutUs___En",
    path: "/En/aboutUs",
    meta: indexe55LUCecEPMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/aboutUs/index.vue").then(m => m.default || m)
  },
  {
    name: "aboutUs___Hk",
    path: "/Hk/aboutUs",
    meta: indexe55LUCecEPMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/aboutUs/index.vue").then(m => m.default || m)
  },
  {
    name: "aboutUs___Cn",
    path: "/Cn/aboutUs",
    meta: indexe55LUCecEPMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/aboutUs/index.vue").then(m => m.default || m)
  },
  {
    name: "aboutUs___Ja",
    path: "/Ja/aboutUs",
    meta: indexe55LUCecEPMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/aboutUs/index.vue").then(m => m.default || m)
  },
  {
    name: "addPassenger___En",
    path: "/En/addPassenger",
    meta: indexKDUDy9cFeDMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/addPassenger/index.vue").then(m => m.default || m)
  },
  {
    name: "addPassenger___Hk",
    path: "/Hk/addPassenger",
    meta: indexKDUDy9cFeDMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/addPassenger/index.vue").then(m => m.default || m)
  },
  {
    name: "addPassenger___Cn",
    path: "/Cn/addPassenger",
    meta: indexKDUDy9cFeDMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/addPassenger/index.vue").then(m => m.default || m)
  },
  {
    name: "addPassenger___Ja",
    path: "/Ja/addPassenger",
    meta: indexKDUDy9cFeDMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/addPassenger/index.vue").then(m => m.default || m)
  },
  {
    name: "confirmation___En",
    path: "/En/confirmation",
    meta: indexMfxDiBfikcMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/confirmation/index.vue").then(m => m.default || m)
  },
  {
    name: "confirmation___Hk",
    path: "/Hk/confirmation",
    meta: indexMfxDiBfikcMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/confirmation/index.vue").then(m => m.default || m)
  },
  {
    name: "confirmation___Cn",
    path: "/Cn/confirmation",
    meta: indexMfxDiBfikcMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/confirmation/index.vue").then(m => m.default || m)
  },
  {
    name: "confirmation___Ja",
    path: "/Ja/confirmation",
    meta: indexMfxDiBfikcMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/confirmation/index.vue").then(m => m.default || m)
  },
  {
    name: "contactUs___En",
    path: "/En/contactUs",
    meta: indexpR8M0pnjMpMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/contactUs/index.vue").then(m => m.default || m)
  },
  {
    name: "contactUs___Hk",
    path: "/Hk/contactUs",
    meta: indexpR8M0pnjMpMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/contactUs/index.vue").then(m => m.default || m)
  },
  {
    name: "contactUs___Cn",
    path: "/Cn/contactUs",
    meta: indexpR8M0pnjMpMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/contactUs/index.vue").then(m => m.default || m)
  },
  {
    name: "contactUs___Ja",
    path: "/Ja/contactUs",
    meta: indexpR8M0pnjMpMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/contactUs/index.vue").then(m => m.default || m)
  },
  {
    name: "destination-id___En",
    path: "/En/destination/:id()",
    meta: _91id_93BviohoFIHGMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/destination/[id].vue").then(m => m.default || m)
  },
  {
    name: "destination-id___Hk",
    path: "/Hk/destination/:id()",
    meta: _91id_93BviohoFIHGMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/destination/[id].vue").then(m => m.default || m)
  },
  {
    name: "destination-id___Cn",
    path: "/Cn/destination/:id()",
    meta: _91id_93BviohoFIHGMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/destination/[id].vue").then(m => m.default || m)
  },
  {
    name: "destination-id___Ja",
    path: "/Ja/destination/:id()",
    meta: _91id_93BviohoFIHGMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/destination/[id].vue").then(m => m.default || m)
  },
  {
    name: "familyAndFriends___En",
    path: "/En/familyAndFriends",
    meta: index1EzbM2KwCvMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/familyAndFriends/index.vue").then(m => m.default || m)
  },
  {
    name: "familyAndFriends___Hk",
    path: "/Hk/familyAndFriends",
    meta: index1EzbM2KwCvMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/familyAndFriends/index.vue").then(m => m.default || m)
  },
  {
    name: "familyAndFriends___Cn",
    path: "/Cn/familyAndFriends",
    meta: index1EzbM2KwCvMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/familyAndFriends/index.vue").then(m => m.default || m)
  },
  {
    name: "familyAndFriends___Ja",
    path: "/Ja/familyAndFriends",
    meta: index1EzbM2KwCvMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/familyAndFriends/index.vue").then(m => m.default || m)
  },
  {
    name: "flightLoading___En",
    path: "/En/flightLoading",
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/flightLoading/index.vue").then(m => m.default || m)
  },
  {
    name: "flightLoading___Hk",
    path: "/Hk/flightLoading",
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/flightLoading/index.vue").then(m => m.default || m)
  },
  {
    name: "flightLoading___Cn",
    path: "/Cn/flightLoading",
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/flightLoading/index.vue").then(m => m.default || m)
  },
  {
    name: "flightLoading___Ja",
    path: "/Ja/flightLoading",
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/flightLoading/index.vue").then(m => m.default || m)
  },
  {
    name: "flights-search-fromCity-toCity___En",
    path: "/En/flights/search/:fromCity()/:toCity()",
    meta: _91toCity_93Ud2TO2thAOMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/flights/search/[fromCity]/[toCity].vue").then(m => m.default || m)
  },
  {
    name: "flights-search-fromCity-toCity___Hk",
    path: "/Hk/flights/search/:fromCity()/:toCity()",
    meta: _91toCity_93Ud2TO2thAOMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/flights/search/[fromCity]/[toCity].vue").then(m => m.default || m)
  },
  {
    name: "flights-search-fromCity-toCity___Cn",
    path: "/Cn/flights/search/:fromCity()/:toCity()",
    meta: _91toCity_93Ud2TO2thAOMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/flights/search/[fromCity]/[toCity].vue").then(m => m.default || m)
  },
  {
    name: "flights-search-fromCity-toCity___Ja",
    path: "/Ja/flights/search/:fromCity()/:toCity()",
    meta: _91toCity_93Ud2TO2thAOMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/flights/search/[fromCity]/[toCity].vue").then(m => m.default || m)
  },
  {
    name: "help___En",
    path: "/En/help",
    meta: indexOYN7gUbbCgMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/help/index.vue").then(m => m.default || m)
  },
  {
    name: "help___Hk",
    path: "/Hk/help",
    meta: indexOYN7gUbbCgMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/help/index.vue").then(m => m.default || m)
  },
  {
    name: "help___Cn",
    path: "/Cn/help",
    meta: indexOYN7gUbbCgMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/help/index.vue").then(m => m.default || m)
  },
  {
    name: "help___Ja",
    path: "/Ja/help",
    meta: indexOYN7gUbbCgMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/help/index.vue").then(m => m.default || m)
  },
  {
    name: "hotDeals-id___En",
    path: "/En/hotDeals/:id()",
    meta: _91id_93JLUGcVLIUIMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/hotDeals/[id].vue").then(m => m.default || m)
  },
  {
    name: "hotDeals-id___Hk",
    path: "/Hk/hotDeals/:id()",
    meta: _91id_93JLUGcVLIUIMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/hotDeals/[id].vue").then(m => m.default || m)
  },
  {
    name: "hotDeals-id___Cn",
    path: "/Cn/hotDeals/:id()",
    meta: _91id_93JLUGcVLIUIMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/hotDeals/[id].vue").then(m => m.default || m)
  },
  {
    name: "hotDeals-id___Ja",
    path: "/Ja/hotDeals/:id()",
    meta: _91id_93JLUGcVLIUIMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/hotDeals/[id].vue").then(m => m.default || m)
  },
  {
    name: "index___En",
    path: "/En",
    meta: indexxkK4ebspFOMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___Hk",
    path: "/Hk",
    meta: indexxkK4ebspFOMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___Cn",
    path: "/Cn",
    meta: indexxkK4ebspFOMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___Ja",
    path: "/Ja",
    meta: indexxkK4ebspFOMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "luggagePayments___En",
    path: "/En/luggagePayments",
    meta: indext7YOkuj35eMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/luggagePayments/index.vue").then(m => m.default || m)
  },
  {
    name: "luggagePayments___Hk",
    path: "/Hk/luggagePayments",
    meta: indext7YOkuj35eMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/luggagePayments/index.vue").then(m => m.default || m)
  },
  {
    name: "luggagePayments___Cn",
    path: "/Cn/luggagePayments",
    meta: indext7YOkuj35eMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/luggagePayments/index.vue").then(m => m.default || m)
  },
  {
    name: "luggagePayments___Ja",
    path: "/Ja/luggagePayments",
    meta: indext7YOkuj35eMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/luggagePayments/index.vue").then(m => m.default || m)
  },
  {
    name: "orderDetail-id___En",
    path: "/En/orderDetail/:id()",
    meta: _91id_932XpjuTRLKXMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/orderDetail/[id].vue").then(m => m.default || m)
  },
  {
    name: "orderDetail-id___Hk",
    path: "/Hk/orderDetail/:id()",
    meta: _91id_932XpjuTRLKXMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/orderDetail/[id].vue").then(m => m.default || m)
  },
  {
    name: "orderDetail-id___Cn",
    path: "/Cn/orderDetail/:id()",
    meta: _91id_932XpjuTRLKXMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/orderDetail/[id].vue").then(m => m.default || m)
  },
  {
    name: "orderDetail-id___Ja",
    path: "/Ja/orderDetail/:id()",
    meta: _91id_932XpjuTRLKXMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/orderDetail/[id].vue").then(m => m.default || m)
  },
  {
    name: "orderList___En",
    path: "/En/orderList",
    meta: indexb0t9BMXb2zMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/orderList/index.vue").then(m => m.default || m)
  },
  {
    name: "orderList___Hk",
    path: "/Hk/orderList",
    meta: indexb0t9BMXb2zMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/orderList/index.vue").then(m => m.default || m)
  },
  {
    name: "orderList___Cn",
    path: "/Cn/orderList",
    meta: indexb0t9BMXb2zMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/orderList/index.vue").then(m => m.default || m)
  },
  {
    name: "orderList___Ja",
    path: "/Ja/orderList",
    meta: indexb0t9BMXb2zMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/orderList/index.vue").then(m => m.default || m)
  },
  {
    name: "payComplete___En",
    path: "/En/payComplete",
    meta: indexFQZvbF57BNMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/payComplete/index.vue").then(m => m.default || m)
  },
  {
    name: "payComplete___Hk",
    path: "/Hk/payComplete",
    meta: indexFQZvbF57BNMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/payComplete/index.vue").then(m => m.default || m)
  },
  {
    name: "payComplete___Cn",
    path: "/Cn/payComplete",
    meta: indexFQZvbF57BNMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/payComplete/index.vue").then(m => m.default || m)
  },
  {
    name: "payComplete___Ja",
    path: "/Ja/payComplete",
    meta: indexFQZvbF57BNMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/payComplete/index.vue").then(m => m.default || m)
  },
  {
    name: "payments___En",
    path: "/En/payments",
    meta: indextbRLLu6mYrMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/payments/index.vue").then(m => m.default || m)
  },
  {
    name: "payments___Hk",
    path: "/Hk/payments",
    meta: indextbRLLu6mYrMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/payments/index.vue").then(m => m.default || m)
  },
  {
    name: "payments___Cn",
    path: "/Cn/payments",
    meta: indextbRLLu6mYrMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/payments/index.vue").then(m => m.default || m)
  },
  {
    name: "payments___Ja",
    path: "/Ja/payments",
    meta: indextbRLLu6mYrMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/payments/index.vue").then(m => m.default || m)
  },
  {
    name: "personalInformation___En",
    path: "/En/personalInformation",
    meta: indexFqLAPZvvYLMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/personalInformation/index.vue").then(m => m.default || m)
  },
  {
    name: "personalInformation___Hk",
    path: "/Hk/personalInformation",
    meta: indexFqLAPZvvYLMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/personalInformation/index.vue").then(m => m.default || m)
  },
  {
    name: "personalInformation___Cn",
    path: "/Cn/personalInformation",
    meta: indexFqLAPZvvYLMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/personalInformation/index.vue").then(m => m.default || m)
  },
  {
    name: "personalInformation___Ja",
    path: "/Ja/personalInformation",
    meta: indexFqLAPZvvYLMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/personalInformation/index.vue").then(m => m.default || m)
  },
  {
    name: "policyContent___En",
    path: "/En/policyContent",
    meta: indexqXZXFvdf16Meta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/policyContent/index.vue").then(m => m.default || m)
  },
  {
    name: "policyContent___Hk",
    path: "/Hk/policyContent",
    meta: indexqXZXFvdf16Meta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/policyContent/index.vue").then(m => m.default || m)
  },
  {
    name: "policyContent___Cn",
    path: "/Cn/policyContent",
    meta: indexqXZXFvdf16Meta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/policyContent/index.vue").then(m => m.default || m)
  },
  {
    name: "policyContent___Ja",
    path: "/Ja/policyContent",
    meta: indexqXZXFvdf16Meta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/policyContent/index.vue").then(m => m.default || m)
  },
  {
    name: "refundPayments___En",
    path: "/En/refundPayments",
    meta: indexwCnobILRbqMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/refundPayments/index.vue").then(m => m.default || m)
  },
  {
    name: "refundPayments___Hk",
    path: "/Hk/refundPayments",
    meta: indexwCnobILRbqMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/refundPayments/index.vue").then(m => m.default || m)
  },
  {
    name: "refundPayments___Cn",
    path: "/Cn/refundPayments",
    meta: indexwCnobILRbqMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/refundPayments/index.vue").then(m => m.default || m)
  },
  {
    name: "refundPayments___Ja",
    path: "/Ja/refundPayments",
    meta: indexwCnobILRbqMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/refundPayments/index.vue").then(m => m.default || m)
  },
  {
    name: "termService___En",
    path: "/En/termService",
    meta: indexvYCTxt37LQMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/termService/index.vue").then(m => m.default || m)
  },
  {
    name: "termService___Hk",
    path: "/Hk/termService",
    meta: indexvYCTxt37LQMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/termService/index.vue").then(m => m.default || m)
  },
  {
    name: "termService___Cn",
    path: "/Cn/termService",
    meta: indexvYCTxt37LQMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/termService/index.vue").then(m => m.default || m)
  },
  {
    name: "termService___Ja",
    path: "/Ja/termService",
    meta: indexvYCTxt37LQMeta || {},
    component: () => import("/var/lib/jenkins/workspace/taro-trip-production/src/pages/termService/index.vue").then(m => m.default || m)
  }
]